module.exports = __webpack_public_path__ + "static/media/warning.3fd64abe.svg";